import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


function AgendaAffichageInfo({ show, quit, info }) {
  return (
    <Modal show={show} onHide={quit}>
    <Modal.Header closeButton>
      <Modal.Title>Informations de l'événement</Modal.Title>
    </Modal.Header>
    <Modal.Body>
    <div className='card'>
        <div className='card-body'>
            <div className='ajout'>
                <form className="Invite_Joueur" > 
                <div>
                    <label htmlFor="nom" className="label-1" >
                    <br />Date de début<br />
                    <input
                        name="date_debut"
                        type="date"
                        id="date_debut"
                        readOnly
                        value={info[1]} 
                    />
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label htmlFor="new_adress" className="label-1" >
                        <br />Date de fin<br />
                            <input
                            name="date_fin"
                            type="date"
                            id="date_fin"
                            readOnly
                            value={info[4]}
                            />
                        </label>
                </div>
                <div>
                    <label htmlFor="nom" className="label-1" >
                    <br />Heure de début<br />
                    <input
                        type="time"
                        id="heure_debut"
                        name="heure_debut"
                        readOnly
                        value={info[2]}  
                        />
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label htmlFor="nom" className="label-1" >
                    <br />Heure de fin<br />
                    <input
                        type="time"
                        id="heure_fin"
                        name="heure_fin"
                        readOnly
                        value={info[3]}
                        />
                    </label>
                </div>
                <div>
                <label htmlFor="nom" className="label-1" >
                    <br />Localisation de l'événement<br />
                    <input
                        type="localisation"
                        id="text"
                        name="localisation"
                        readOnly
                        value={info[0]._def.title.split(',')[1]}
                        />
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label htmlFor="nom" className="label-1" required>
                    <br />Couleur<br />
                    <label className={`color-option vert ${info[0]._def.ui.backgroundColor === 'rgba(0, 230, 118, 1)' ? 'selected' : ''}`}  >
                        <input type="radio" name="couleur" value="vert" style={{display:"none"}}  />
                    </label>
                    &nbsp;
                    <label className={`color-option jaune ${info[0]._def.ui.backgroundColor === 'rgba(242, 177, 52, 1)' ? 'selected' : ''}`} >
                        <input type="radio" name="couleur" value="jaune" style={{display:"none"}} />
                    </label>
                    &nbsp;
                    <label className={`color-option rouge ${info[0]._def.ui.backgroundColor === 'rgba(235, 85, 59, 1)' ? 'selected' : ''}`} >
                        <input type="radio" name="couleur" value="rouge" style={{display:"none"}} />
                    </label>
                    &nbsp;
                    <label className={`color-option bleu ${info[0]._def.ui.backgroundColor === 'rgba(30, 0, 244, 0.8)' ? 'selected' : ''}`} >
                        <input type="radio" name="couleur" value="bleu" style={{display:"none"}} />
                    </label>
                    </label>
                </div>
                <div>
                    <label htmlFor="nom" className="label-1" >
                    <br />Sujet de l'événement<br />
                        <textarea placeholder=" Entraînement musculaire..." value={info[0]._def.title.split(',')[0]} readOnly rows="2" cols="40" ></textarea>
                    </label>
                </div>
                <br></br>
                </form>
            </div>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={quit}>
        Quitter
      </Button>
    </Modal.Footer>
  </Modal>


  );
}

export default AgendaAffichageInfo;
